import CardHeader from "@nodes/@material-ui/core/CardHeader";
import Typography from "@nodes/@material-ui/core/Typography";
import PersonIcon from "@nodes/@material-ui/icons/Person";

const DebtorNameHeader = ({ debtor, children }) => {
  // Defensive: `debtor` can be undefined when a caller's redux/SWR lookup misses
  // (e.g. the loans/payments lists are momentarily empty right after an IndexedDB
  // eviction, before recovery repopulates them). Reading `debtor.name` off
  // undefined here threw "Cannot read properties of undefined (reading 'name')"
  // and tripped the ErrorBoundary on the receipt/detail pages. Guard so the
  // header renders empty instead of crashing while the data recovers.
  const d = debtor || {};
  return (
    <CardHeader
      action={children}
      title={
        <Typography variant="body1" component="p" className="font-weight-bold">
          <PersonIcon /> {d.name} {d.nickname && `(${d.nickname})`}
        </Typography>
      }
    />
  );
};

export default DebtorNameHeader;
